var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistancia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.993,
    height: 19.134,
    viewBox: "0 0 14.993 19.134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7278",
    "data-name": "Path 7278",
    d: "M-616.815,844.337c0-3.7,1.987-6.565,5.034-7.579a7.436,7.436,0,0,1,9.846,5.916,7.736,7.736,0,0,1-1.749,6.373q-2.473,3.024-4.961,6.035a.769.769,0,0,1-1.35,0c-1.721-2.1-3.46-4.176-5.157-6.29A7.415,7.415,0,0,1-616.815,844.337Zm7.5-3.568a2.945,2.945,0,0,0-2.948,2.952,2.947,2.947,0,0,0,2.947,2.932,2.951,2.951,0,0,0,2.937-2.942A2.946,2.946,0,0,0-609.315,840.769Z",
    transform: "translate(616.815 -836.35)",
    fill: "#8ae7e0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistancia);
export default __webpack_public_path__ + "static/media/Distancia.cf007c8eb754f194e6db9140fe1b9cd0.svg";
export { ForwardRef as ReactComponent };